export const ORDER_TYPE_CODE = {
  BO: 'BO', //c’est une commande back order
  H: 'H', //c’est une commande de roue complète
  SUBSTITUTION: 'S', // c’est une commande de substitution
  REGULATION: 'R', // c’est une commande de régularisation EAN ou c’est une commande de régularisation de zéro (sans commande d’origine)
  REGULATION_QUANTITY: 'Q', // c’est une commande de régularisation quantité
  REFUSAL_TAKE_BACK: 'D', // c’est une commande de reprise/refus
  DESADV_MANUF: 'M', // (desadv = bon de livraison)
  PHONE: 'W', // RC WYZ
  MANUAL: 'MNL', // commande manuelle passée par la finance
  CAPTATION: 'C',
  FLEET: 'F',
  WHOLESALE_FLEET: 'FG',
  API: 'A',
  DESTOCKING: 'DST',
} as const;

export const ORDER_SUPPLIER_TYPE_NAME_ENUM = {
  DISTRIBUTOR_WYZ: 'Distributeur WYZ',
  MANUFACTURER: 'Manufacturier',
  DISTRIBUTOR_PLATFORM: 'Distributeur Plateforme',
} as const;

export const ORDER_STATUSES = {
  WAITING: 10,
  SEND_SUPPLIER: 15,
  DELIVERY_PROGRESS: 30,
  CANCELLED_BY_SUPPLIER: 50,
  CANCELLED_BY_CLIENT: 60,
  CANCELLED_BY_WYZ: 70,
} as const;

export const CANCELLED_ORDER_STATUSES = {
  CANCELLED_BY_SUPPLIER: ORDER_STATUSES.CANCELLED_BY_SUPPLIER,
  CANCELLED_BY_CLIENT: ORDER_STATUSES.CANCELLED_BY_CLIENT,
  CANCELLED_BY_WYZ: ORDER_STATUSES.CANCELLED_BY_WYZ,
} as const;

export const OFFER_TYPE = {
  MANUFACTURER: 'manuf',
  ALTERNATIVE: 'wyz_offer',
  DISTRIBUTOR_PLATFORM: 'distributor_platform',
  CENTRAL_STOCK: 'central_stock',
  LOCAL_STOCK: 'local_stock',
} as const;

export const SUPPLIER_BEHAVIOR_ENUM = {
  MANUFACTURER: 'MANUFACTURIER',
  INTRA_GROUP: 'INTRA_GROUP',
  ALTERNATIVE_WYZ: 'DEPANNAGE_WYZ',
} as const;
